import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const maintenanceRequiredListDuck = makeReportingDuck(
  'maintenanceRequired',
  (filters) => getPaginated('/reports/maintenance-required/', filters),
  () => getApi('/reports/maintenance-required/info/')
);

export type MaintenanceRequiredAction = ReportingDuckActions<
  typeof maintenanceRequiredListDuck
>;
